import { Price } from '../../../../types';
import { SortOption, SortOptionEnum } from './types';

export const sortByPrice = (selectedSort: SortOption, prices: Price[]) => {
  return [...prices].sort((a, b) => {
    let aPrice;
    let bPrice;

    if (selectedSort === SortOptionEnum.PRICE_INCLUDES_SHIPPING) {
      aPrice = a.price && a.price.inclShipping;
      bPrice = b.price && b.price.inclShipping;
    } else {
      aPrice = a.price && a.price.exclShipping;
      bPrice = b.price && b.price.exclShipping;
    }

    // If price info is null or undefined, move them to bottom of list
    if (!aPrice) {
      return 1;
    }
    if (!bPrice) {
      return -1;
    }

    return aPrice - bPrice;
  });
};
